// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * A namespace-qualified name carried as a value.
 */
export class QualifiedNameValue implements flatbuffers.IUnpackableObject<QualifiedNameValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): QualifiedNameValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsQualifiedNameValue(
    bb: flatbuffers.ByteBuffer,
    obj?: QualifiedNameValue,
  ): QualifiedNameValue {
    return (obj || new QualifiedNameValue()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsQualifiedNameValue(
    bb: flatbuffers.ByteBuffer,
    obj?: QualifiedNameValue,
  ): QualifiedNameValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new QualifiedNameValue()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  namespaceIndex(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startQualifiedNameValue(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addNamespaceIndex(builder: flatbuffers.Builder, namespaceIndex: number) {
    builder.addFieldInt16(0, namespaceIndex, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static endQualifiedNameValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // name
    return offset;
  }

  static createQualifiedNameValue(
    builder: flatbuffers.Builder,
    namespaceIndex: number,
    nameOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    QualifiedNameValue.startQualifiedNameValue(builder);
    QualifiedNameValue.addNamespaceIndex(builder, namespaceIndex);
    QualifiedNameValue.addName(builder, nameOffset);
    return QualifiedNameValue.endQualifiedNameValue(builder);
  }

  unpack(): QualifiedNameValueT {
    return new QualifiedNameValueT(this.namespaceIndex(), this.name());
  }

  unpackTo(_o: QualifiedNameValueT): void {
    _o.namespaceIndex = this.namespaceIndex();
    _o.name = this.name();
  }

  unpackFields(...fields: string[]): QualifiedNameValueT {
    const t = new QualifiedNameValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("namespace_index")) {
      t.namespaceIndex = this.namespaceIndex();
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    return t;
  }
}

export class QualifiedNameValueT implements flatbuffers.IGeneratedObject {
  constructor(
    public namespaceIndex: number = 0,
    public name: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const name = this.name !== null ? builder.createString(this.name!) : 0;

    return QualifiedNameValue.createQualifiedNameValue(builder, this.namespaceIndex, name);
  }

  clone(): QualifiedNameValueT {
    const obj = new QualifiedNameValueT();
    obj.namespaceIndex = this.namespaceIndex;
    obj.name = this.name;
    return obj;
  }

  equals(other: QualifiedNameValueT): boolean {
    if (this.namespaceIndex !== other.namespaceIndex) return false;
    if (this.name !== other.name) return false;
    return true;
  }
}

export function verifyQualifiedNameValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "name");
  } finally {
    verifier.popDepth();
  }
}
